import { Link } from "react-router-dom";
import { categories } from "@/mocks/categories";
import { films } from "@/mocks/films";

export default function CategoryShortcuts() {
  return (
    <section className="mx-auto w-full px-4 md:px-6">
      <div className="grid grid-cols-2 gap-3 md:grid-cols-4 md:gap-5">
        {categories.map((cat) => {
          const count = films.filter((f) => f.category === cat.key).length;
          return (
            <Link
              key={cat.key}
              to={`/category?type=${cat.key}`}
              className="group relative flex h-32 cursor-pointer flex-col justify-between overflow-hidden rounded-lg border border-background-200 bg-background-50 p-3 transition-all duration-300 hover:border-primary-200 md:h-40 md:p-5"
            >
              <img
                src={cat.cover}
                alt={`${cat.name}分类封面`}
                className="absolute inset-0 h-full w-full object-cover opacity-90 transition-transform duration-500 group-hover:scale-105"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/85 via-foreground-950/40 to-transparent"></div>
              <span className="relative flex h-9 w-9 items-center justify-center rounded-lg bg-accent-500 text-foreground-950">
                <i className={`${cat.icon} text-xl`}></i>
              </span>
              <div className="relative">
                <h3 className="text-base font-bold text-background-50 md:text-lg">
                  {cat.name}
                </h3>
                <p className="mt-0.5 text-xs text-background-200">
                  共 {count} 部作品
                </p>
              </div>
            </Link>
          );
        })}
      </div>
    </section>
  );
}